import { ComponentProps, ReactNode } from 'react';
import { Block } from '../../Block/Block';
import { Background } from '../../Section/background';
import { Section } from '../../Section/Section';
import { SectionName } from '../../../observability/tracking/events';
import { COLOR_KEYS } from '../../../constants';
import { BuilderComponentProps } from '../../../builder';

type BlockProps = Omit<ComponentProps<typeof Block>, 'isPageWidth' | 'media'>;

interface Props extends BlockProps, BuilderComponentProps {
  sectionSubheading?: string;
  sectionHeading?: string;
  media: ReactNode;
  background?: Background;
}

export function BlockSection({
  sectionHeading,
  sectionSubheading,
  media,
  background = COLOR_KEYS.transparent,
  builderBlock,
  ...otherProps
}: Props) {
  const getBackground = () => {
    const colorMap: Partial<Record<Background, Background>> = {
      ocean10: COLOR_KEYS.blue10,
      sun10: COLOR_KEYS.neutral200,
      sun20: COLOR_KEYS.neutral200,
      lava10: COLOR_KEYS.cream,
    };

    return Object.prototype.hasOwnProperty.call(colorMap, background)
      ? colorMap[background]
      : background;
  };

  return (
    <Section
      background={getBackground()}
      contentWidth="padded"
      heading={sectionHeading}
      layerName={builderBlock?.layerName}
      sectionToTrack={SectionName.BlockSection}
      subheading={sectionSubheading}
    >
      <Block {...otherProps} isPageWidth={true} media={media} />
    </Section>
  );
}
